import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../widgets/Head';
import { Hero } from '../widgets/Hero';
import ContentWrapper from '../widgets/ContentWrapper';
import Section from '../widgets/Section';

import * as css from './ContactThankyou.m.css';

const factory = create();

export const ContactThankyou = factory(function ContactThankyou() {
	return (
		<div classes={css.root}>
			<Head
				title="Contact Us | SitePen"
				description="Headquartered in Palo Alto, CA, we are located throughout the US and UK, send us a note to hello@sitepen.com. We&#039;ll get back to you ASAP."
			/>

			<Hero
				background="level2BluePurple"
				align="center"
				titlePaddingBottom="sm"
				paddingBottom="xs"
			>
				{{
					xlTitle: 'Thank You!',
					blurb: (
						<virtual>
							Thank you for contacting us! We look forward to speaking with you and
							will be in touch shortly.
						</virtual>
					)
				}}
			</Hero>

			<Section type="trailing">
				<ContentWrapper>
					<iframe
						title="Latest insights"
						id="latest-insights"
						src="preview/latest-insights"
						classes={[css.recentPosts]}
					/>
				</ContentWrapper>
			</Section>
		</div>
	);
});

export default ContactThankyou;
